import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: ()=>import('../views/HomePage.vue')
  },
  {
    path:'/LaboratoryServices',
    name:'LaboratoryServices',
    component:()=>import('../views/LaboratoryServices.vue')
  }
  ,
  {
   path: '/about',
   name: 'About',
   component: () => import('../views/About.vue')
  },
  {
    path:'/news',
    name:'news',
    component: () => import('../views/News.vue')
  },
  {
    path : '/business',
    name : 'business',
    component :() => import('../views/business.vue')
  },
  {
    path:'/sale',
    name : 'sale',
    component : () => import('../views/sale.vue')
  },
  {
    path:'/spareParts',
    name : 'spareParts',
    component : () => import('../views/spareParts.vue')
  },
  {
    path:'/construction',
    name : 'construction',
    component : () => import('../views/construction.vue')
  },
  {
    path:'/newsDetail',
    name:'newsDetail',
    component:()=>import('../views/newsDetail.vue')
  },
  {
    path : '*',
    redirect:'/'
  }
]

const router = new VueRouter({
  routes
})

export default router
